import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./files-details.scss";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { useState } from "react";
import downCaret from "assets/images/downCaret.png";
import upCaret from "assets/images/upCaret.png";
import { splitAndCapitalizeWords } from "utilities/string";

const iconMappings: { [key: string]: IconDefinition } = {
  jpeg: solid("file-image"),
  jpg: solid("file-jpg"),
  jpe: solid("file-image"),
  doc: solid("file-lines"),
  docx: solid("file-lines"),
  default: solid("file-pdf"),
};

export interface Filedetailsprops {
  readonly fileName: string;
  readonly handlePreviewDocument?: () => void;
}

export interface Fileuploadprops {
  readonly uploadedby: string;
  readonly createdDate: string;
}
export interface FileErrorProps {
   readonly invalidReason?: string;
}
 
export default function FileDetails({ fileName, handlePreviewDocument }: Filedetailsprops) {
  const fileExtension = fileName.split(".").pop() ?? "";
  const iconName =
    iconMappings[fileExtension.toLowerCase()] ?? iconMappings.default;
  return (
    <div className="file-details">
      <div>
        <FontAwesomeIcon className="file-details__icon" icon={iconName} />
      </div>
      <div
        className="file-details__filename"
        role="button"
        tabIndex={0}
        onClick={handlePreviewDocument}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handlePreviewDocument?.();
          }
        }}
      >
        {fileName}
      </div>
    </div>
  );
}

export function FileUploadedBy({ uploadedby, createdDate }: Fileuploadprops) {
  return (
    <div className="file-upload">
      <div className="file-upload__uploadedby">{uploadedby}</div>
      <div className="file-upload__createddate">{createdDate}</div>
    </div>
  );
}

export function FileErrorBanner({ invalidReason }: FileErrorProps) {
  const [showError, setShowError] = useState(false);
  return (
    <div className={`file-card__error ${showError ? "open" : ""}`}>
      <div  className="error-label" onClick={() => setShowError(!showError)} >
        Invalid <img src={showError ? upCaret : downCaret} alt={showError ? "Collapse error details" : "Expand error details"} />
      </div>
      <div className="error-message"> {invalidReason ? splitAndCapitalizeWords(invalidReason) : null} </div>
    </div>
  );
}
